import get from 'lodash/get';
import {
    GET_ORDERS_SUCCESS,
    GET_MY_ORDERS,
    GET_MY_ORDERS_SUCCESS,
    GET_MY_ORDERS_ERROR,
} from '../actionTypes/MyOrdersActionTypes';

const INITIAL_STATE = {
    cachedCall: undefined,
    myOrders: [],
    pages: 0,
    page: 1,
    limit: 10,
    totalOrders: 0,
    filterDates: [],
    isLoading: false,
    filters: {},
};

function MyOrdersReducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case GET_ORDERS_SUCCESS: {
            return { ...state, cachedCall: action.ordersHistory };
        }
        case GET_MY_ORDERS: {
            return {
                ...state,
                isLoading: true,
                filters: { filter: get(action, 'payload.filter', '6') },
            };
        }

        case GET_MY_ORDERS_SUCCESS: {
            const response = get(action.ordersHistory, 'response', {});
            if (!get(response, 'data.errorCode', '')) {
                const { orders, pages, page, limit, filterDates, totalOrders, filters } = get(
                    response,
                    'data',
                    {}
                );
                const offset = (filters.page - 1) * filters.limit;
                const ordersStartNumber = offset + 1;
                const ordersEndNumber =
                    get(orders, 'length', 0) >= filters.limit
                        ? get(orders, 'length', 0) * page
                        : totalOrders; // 13
                return {
                    ...state,
                    myOrders: orders,
                    pages,
                    page,
                    limit,
                    filterDates,
                    totalOrders,
                    filters,
                    ordersStartNumber,
                    ordersEndNumber,
                    isSuccess: true,
                    error: {},
                    isLoading: false,
                };
            }

            return {
                ...INITIAL_STATE,
                error: get(response, 'data', { errorCode: '' }),
                isLoading: false,
            };
        }

        case GET_MY_ORDERS_ERROR: {
            return { ...state, error: action.error, isLoading: false };
        }

        default:
            return state;
    }
}

MyOrdersReducer.reducerName = 'ordersHistory';
export default MyOrdersReducer;
